module.exports = __webpack_public_path__ + "static/media/check_grey.96a24e17.svg";